var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.imageElement
    ? _c(
        "div",
        { staticClass: "crossword-properties-wrapper" },
        [
          _c("label", [_vm._v("Styles")]),
          _vm._v(" "),
          _c("div", { staticClass: "divider mb-3" }),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            staticClass: "style-mode w-100 mb-3",
            attrs: {
              type: "radio",
              size: "sm",
              "no-icon": "",
              wide: "",
              items: _setup.STYLE_MODES,
              disabled: _setup.disabled,
            },
            model: {
              value: _setup.alternateStyles,
              callback: function ($$v) {
                _setup.alternateStyles = $$v
              },
              expression: "alternateStyles",
            },
          }),
          _vm._v(" "),
          _setup.styles.length
            ? _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c(_setup.CrosswordStyleList, {
                    attrs: {
                      items: _setup.styles,
                      disabled: _setup.disabled,
                      "selected-id": _setup.testStyleId,
                    },
                    on: {
                      select: _setup.selectTestStyle,
                      edit: _setup.editStyle,
                      remove: _setup.removeStyle,
                      reorder: _setup.reorderStyles,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CButton, {
            staticClass: "w-100 mb-3",
            attrs: {
              size: "md",
              text: "Add Crossword Style",
              variant: "light",
              icon: ["far", "plus"],
              disabled: _setup.disabled,
            },
            on: { click: _setup.openSelectModal },
          }),
          _vm._v(" "),
          _c(_setup.CInput, {
            staticClass: "mb-3",
            attrs: {
              type: "number",
              label: "Tile Spacing (px)",
              disabled: _setup.disabled,
              error: _setup.tileSpacingValue === undefined,
              "error-msg": `Use a value between ${_setup.MIN_TILE_SPACING} and ${_setup.MAX_TILE_SPACING}`,
            },
            on: { blur: _setup.onTileSpacingChanged },
            model: {
              value: _setup.tileSpacing,
              callback: function ($$v) {
                _setup.tileSpacing = $$v
              },
              expression: "tileSpacing",
            },
          }),
          _vm._v(" "),
          _c("label", [_vm._v("Scrabble Mode")]),
          _vm._v(" "),
          _c("div", { staticClass: "divider mb-3" }),
          _vm._v(" "),
          _c(_setup.CCheckbox, {
            staticClass: "mb-3",
            attrs: {
              switch: "",
              label: "Show letter values",
              disabled: _setup.disabled,
            },
            model: {
              value: _setup.scrabbleMode,
              callback: function ($$v) {
                _setup.scrabbleMode = $$v
              },
              expression: "scrabbleMode",
            },
          }),
          _vm._v(" "),
          _setup.scrabbleMode
            ? _c(_setup.CSelect, {
                staticClass: "mb-3",
                attrs: {
                  label: "Select a language",
                  "model-transform": _setup.valueReducer,
                  options: _setup.LANGUAGE_OPTIONS,
                  clearable: false,
                  disabled: _setup.disabled,
                },
                model: {
                  value: _setup.language,
                  callback: function ($$v) {
                    _setup.language = $$v
                  },
                  expression: "language",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CrosswordStyleSelectModal, {
            attrs: { "added-preset-ids": _setup.addedPresetIds },
            on: {
              select: _setup.onPresetSelected,
              "create-custom": _setup.onCreateCustom,
            },
            model: {
              value: _setup.selectModalOpen,
              callback: function ($$v) {
                _setup.selectModalOpen = $$v
              },
              expression: "selectModalOpen",
            },
          }),
          _vm._v(" "),
          _c(_setup.CrosswordCustomStyleModal, {
            attrs: {
              "default-name": _setup.nextCustomStyleName,
              "style-to-edit": _setup.styleToEdit,
            },
            on: {
              save: _setup.onCustomStyleSaved,
              back: _setup.onCustomStyleBack,
            },
            model: {
              value: _setup.customModalOpen,
              callback: function ($$v) {
                _setup.customModalOpen = $$v
              },
              expression: "customModalOpen",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }